import { z } from 'zod'

/**
 * Trims leading and trailing whitespace, then rejects empty strings.
 *
 * Use this for string values where blank or whitespace-only input should not be
 * treated as a meaningful value.
 */
export const StringSchema = z.string().trim().min(1)
export type StringSchemaType = z.infer<typeof StringSchema>
